export const extractNumberFromString = (inputString) => {
	let numberString = inputString;
	if (inputString.includes("$")) {
		numberString = inputString.replace(/[^\d.]/g, "");
	}
	const number = parseFloat(numberString);

	return number;
};
